import { FC } from "react";

import { DesignToken, Info, Text, Tooltip } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

import { connectionStatusDotStyles } from "./styles";

interface IProps {
  installed: boolean;
}

const StatusDot: FC<IProps> = ({ installed }) => (
  <div css={connectionStatusDotStyles(installed)} role="presentation" aria-hidden />
);

export const InstallationStatus: FC<IProps> = ({ installed }) => (
  <Tooltip
    triggerRenderer={() => (
      <Flex alignItems="center" gap="4px" data-testid="installation-status">
        <StatusDot installed={installed} />
        <Text bold size="xs" uppercase customColor={withVar(DesignToken.ContentBasicPrimary)}>
          {installed ? "Installed" : "Not installed"}
        </Text>
      </Flex>
    )}
    placement="top"
    theme="invert"
  >
    <Info
      text={
        installed
          ? "The widget is installed correctly on your website. Now, all forms filled out by customers will be turned into tickets and land directly in HelpDesk."
          : "Copy the code and paste it before the closing </body> tag to install the widget on your website and start getting customer messages."
      }
    />
  </Tooltip>
);
